export default __webpack_public_path__ + "static/media/baptiste-icon.406ac962.webp";